<template>
    <div class="container">
        <div class="row">
          <v-spacer></v-spacer>
          <div class="d-flex poweredByWeb caption">
            <a
              href="http://www.autoit.dk/web/"
              class="d-flex align-center"
              target="_blank"
            >
              <img height="20" class="mr-1" src="/auto-it-logo.png" alt="" />
              <span>Powered by Auto IT</span>
            </a>
          </div>
          <v-spacer></v-spacer>
        </div>
      </div>
</template>


<script>
import Vue from 'vue';
export default Vue.extend({
  name: 'PoweredByAutoIt'
})
</script>